import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsBannerSlideModel } from '../../../models/news-banner.model';

@Component({
  selector: 'app-news-banner-slider',
  templateUrl: './news-banner-slider.component.html',
  styleUrl: './news-banner-slider.component.scss',
  standalone: false,
})
export class NewsBannerSliderComponent {
  @Input() newsBannerSlides: NewsBannerSlideModel[] = [];
  @Input() isLoading: boolean = true;
  @Input() showButtons: boolean = true;
  @Output() onDelete: EventEmitter<NewsBannerSlideModel> = new EventEmitter();
  @Output() onEdit: EventEmitter<NewsBannerSlideModel> = new EventEmitter();

  private placeholderSlide: NewsBannerSlideModel = {
    title: 'Keine News vorhanden!',
    description: 'Aktuell sind keine News vorhanden.',
    teaserText: 'Keine News vorhanden!',
    color0: '#807B78',
    color70: '#E6E6EB',
    color80: '#F0F0F3',
  };

  get slides(): NewsBannerSlideModel[] {
    return this.newsBannerSlides.length
      ? this.newsBannerSlides
      : [this.placeholderSlide];
  }

  onEditSlide(slide: NewsBannerSlideModel): void {
    this.onEdit.emit(slide);
  }

  onDeleteSlide(slide: NewsBannerSlideModel): void {
    this.onDelete.emit(slide);
  }
}
